<template>
  <div class="device-two-page">
    <management-table
      title="电表数据"
      eyebrow="Ammeter Data"
      table-class="device-two-table"
      :data="tableData"
      :loading="loading"
      :current-page="query.pageNum"
      :page-size="query.pageSize"
      :total="total"
      empty-text="暂无电表数据"
      @current-change="onPageChange"
    >
      <template slot="filters">
        <div class="search-item">
          <label class="search-label">电站名称:</label>
          <el-select
            v-model="query.stationId"
            class="search-select"
            clearable
            filterable
            :filter-method="filterStation"
            @visible-change="onStationDropdownVisible"
            placeholder="请选择或输入电站名称"
          >
            <el-option
              v-for="item in stationList"
              :key="item.id"
              :label="item.stationName"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="search-item">
          <label class="search-label">电表名称:</label>
          <el-select
            v-model="query.id"
            class="search-select"
            clearable
            filterable
            placeholder="请选择电表"
          >
            <el-option
              v-for="item in deviceList"
              :key="item.id"
              :label="item.deviceName"
              :value="item.id"
            />
          </el-select>
        </div>
      </template>

      <template slot="actions">
        <el-button type="primary" icon="el-icon-search" class="search-btn" @click="serch">搜索</el-button>
      </template>

      <template slot="columns">
        <el-table-column type="index" fixed="left" width="50" label="序号" align="center" />
        <el-table-column label="电站名称" prop="stationName" min-width="150" align="center" show-overflow-tooltip />
        <el-table-column label="电表名称" prop="deviceName" min-width="150" align="center" show-overflow-tooltip />
        <el-table-column label="第一路电压" min-width="130" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.dyldy != null">{{ scope.row.dyldy }}V</span>
          </template>
        </el-table-column>
        <el-table-column label="总电流" min-width="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.zdl != null">{{ scope.row.zdl }}A</span>
          </template>
        </el-table-column>
        <el-table-column label="总有功功率" min-width="140" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.zyggl != null">{{ scope.row.zyggl }}KW</span>
          </template>
        </el-table-column>
        <el-table-column label="总有向有功电能" min-width="160" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.zyxygdn != null">{{ scope.row.zyxygdn }}kWh</span>
          </template>
        </el-table-column>
        <el-table-column label="数据时间" width="170" prop="uploadTime" align="center" show-overflow-tooltip />
        <el-table-column label="操作" fixed="right" width="90" align="center">
          <template slot-scope="scope">
            <span class="table-operate" @click="showDetails(scope.row)">查看</span>
          </template>
        </el-table-column>
      </template>
    </management-table>

    <el-dialog
      title="数据详情"
      :visible.sync="showInfo"
      width="850px"
      custom-class="ammeter-dialog"
    >
      <div class="dialog-content">
        <el-row class="dialog-item">
          <el-col :span="12">
            <div class="dialog-label">电站名称:</div>
            <div class="dialog-value">{{ formObject.stationName }}</div>
          </el-col>
          <el-col :span="12">
            <div class="dialog-label">电表名称:</div>
            <div class="dialog-value">{{ formObject.deviceName }}</div>
          </el-col>
        </el-row>
        <el-row class="dialog-item">
          <el-col :span="12">
            <div class="dialog-label">第一路电压:</div>
            <div v-if="formObject.dyldy != null" class="dialog-value">{{ formObject.dyldy }}V</div>
          </el-col>
          <el-col :span="12">
            <div class="dialog-label">总电流:</div>
            <div v-if="formObject.zdl != null" class="dialog-value">{{ formObject.zdl }}A</div>
          </el-col>
        </el-row>
        <el-row class="dialog-item">
          <el-col :span="12">
            <div class="dialog-label">总有功功率:</div>
            <div v-if="formObject.zyggl != null" class="dialog-value">{{ formObject.zyggl }}KW</div>
          </el-col>
          <el-col :span="12">
            <div class="dialog-label">总有向有功电能:</div>
            <div v-if="formObject.zyxygdn != null" class="dialog-value">{{ formObject.zyxygdn }}kWh</div>
          </el-col>
        </el-row>
        <el-row class="dialog-item">
          <el-col :span="12">
            <div class="dialog-label">数据时间:</div>
            <div class="dialog-value">{{ formObject.uploadTime }}</div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ManagementTable from '../../components/ManagementTable.vue';

export default {
  name: 'DeviceTwo',
  components: {
    ManagementTable
  },
  props: {
    id: {
      required: false,
      type: Number
    }
  },
  data() {
    return {
      showInfo: false,
      formObject: {},
      loading: false,
      tableData: [],
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 9,
        deviceType: 2,
        id: null,
        stationId: null
      },
      deviceList: [],
      allStationList: [],
      stationList: []
    };
  },
  mounted() {
    if (this.id != null) this.query.id = this.id;
    this.loadStationList();
    this.loadAllList();
    this.loadPage();
  },
  methods: {
    showDetails(row) {
      this.formObject = row;
      this.showInfo = true;
    },
    onPageChange(val) {
      this.query.pageNum = val;
      this.loadPage();
    },
    serch() {
      this.query.pageNum = 1;
      this.loadPage();
    },
    loadPage() {
      this.loading = true;
      this.$request.post('/api/device/gf/db/page', this.query).then(response => {
        if (response.data.result) {
          this.tableData = response.data.data.list;
          this.total = response.data.data.totalCount;
        } else {
          this.$message.error('获取电表数据失败,请联系管理员!');
        }
      }).catch(() => {
        this.$message.error('网络异常，获取电表数据失败！');
      }).finally(() => {
        this.loading = false;
      });
    },
    loadStationList() {
      this.$request.get('/api/power/station/options').then(response => {
        if (response.data.result) {
          this.allStationList = response.data.data || [];
          this.stationList = this.allStationList.slice();
        } else {
          this.$message.error('获取电站列表失败,请联系管理员!');
        }
      }).catch(() => {
        this.$message.error('网络异常，获取电站列表失败！');
      });
    },
    filterStation(query) {
      const keyword = String(query || '').trim().toLocaleLowerCase();
      this.stationList = keyword ? this.allStationList.filter(item =>
        String(item.stationName || '').toLocaleLowerCase().includes(keyword)
      ) : this.allStationList.slice();
    },
    onStationDropdownVisible(visible) {
      if (visible) this.stationList = this.allStationList.slice();
    },
    // 两个数据页面共用完整设备列表
    loadAllList() {
      const queryForm = { pageNum: 1, pageSize: 10000 };
      this.$request.post('/api/device/page', queryForm).then(response => {
        if (response.data.result) {
          this.deviceList = response.data.data.list;
        } else {
          this.$message.error('获取设备列表失败,请联系管理员!');
        }
      }).catch(() => {
        this.$message.error('网络异常，获取设备列表失败！');
      });
    }
  }
};
</script>

<style scoped>
.device-two-page {
  width: 100%;
  height: 100%;
  min-height: 0;
}

.table-operate {
  color: var(--solar-primary, #00ccff);
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s ease;
}

.table-operate:hover {
  color: var(--solar-primary, #0099ff);
  text-decoration: underline;
}

/deep/ .ammeter-dialog {
  background-color: var(--solar-surface, #002b4d) !important;
  border: 1px solid var(--solar-border, #003c66) !important;
}

/deep/ .ammeter-dialog .el-dialog__header {
  background-color: var(--solar-page, #001a33) !important;
  border-bottom: 1px solid var(--solar-border, #003c66) !important;
}

/deep/ .ammeter-dialog .el-dialog__title,
/deep/ .ammeter-dialog .el-dialog__close {
  color: var(--solar-text, #87cefa) !important;
}

/deep/ .ammeter-dialog .el-dialog__close:hover {
  color: var(--solar-primary, #00ccff) !important;
}

/deep/ .ammeter-dialog .el-dialog__body {
  background-color: var(--solar-surface, #002b4d) !important;
}

.dialog-content {
  padding: 8px 0;
}

.dialog-item {
  display: flex;
  align-items: center;
  margin-top: 12px;
}

.dialog-label {
  width: 120px;
  color: var(--solar-text, #87cefa);
  font-size: 14px;
}

.dialog-value {
  color: var(--solar-text-strong, #fff);
  font-size: 14px;
}

@media (max-width: 760px) {
  /* 消除移动端覆盖式滚动条和亚像素取整造成的固定列右侧漏底。 */
  /deep/ .device-two-table .el-table__fixed-right {
    right: 0 !important;
    background-color: var(--solar-surface, #002b4d) !important;
  }

  /deep/ .device-two-table .el-table__fixed-right::after {
    position: absolute;
    z-index: 4;
    top: 0;
    right: -1px;
    bottom: 0;
    width: 2px;
    background-color: var(--solar-surface, #002b4d);
    content: '';
    pointer-events: none;
  }
}
</style>
